import envVariables from '../consts/envVariables';

export const consoleMock = (functions) => {
    if (envVariables.ENV !== 'prd') {
        Object.assign(window, functions);
    }
};
